export const GET_OLD_CHATS = 'GET_OLD_CHATS'
export const CREATE_NEW_CHAT = 'CREATE_NEW_CHAT'
export const SET_ACTIVE_CHAT = 'SET_ACTIVE_CHAT'
export const DELETE_CHAT_HISTORY = 'DELETE_CHAT_HISTORY'
export const CLEAR_CHAT_HISTORY = 'CLEAR_CHAT_HISTORY'
export const UPADTE_CHAT_LABEL = 'UPADTE_CHAT_LABEL'
export const SET_SEARCH_QUERY = 'SET_SEARCH_QUERY'
